<template>
  <div id="app">
    <NavBar
        :currentUser="currentUser"
        @open-login="showLoginModal"
        @logout="handleLogout"
    />
    <main class="content">
      <router-view />
    </main>
    <BlogFooter />
    <LoginModal
        v-if="showLogin"
        @close="showLogin = false"
        @login-success="handleLoginSuccess"
    />
  </div>
</template>

<script>
import NavBar from './components/NavBar.vue'
import LoginModal from './components/LoginModal.vue'
import BlogFooter from "@/components/BlogFooter.vue";

export default {
  components: {
    BlogFooter,
    NavBar,
    LoginModal
  },
  data() {
    return {
      showLogin: false,
      currentUser: localStorage.getItem('currentUser') || null
    }
  },
  methods: {
    showLoginModal() { // 添加显示登录模态框方法
      this.showLogin = true;
    },
    handleLogout() { // 添加登出处理方法
      this.currentUser = null;
      localStorage.clear();
    },
    handleLoginSuccess(user) { // 添加登录成功处理方法
      this.currentUser = user;
      localStorage.setItem('currentUser', user);
      this.showLogin = false;
    }
  }
}
</script>

<style>
/* 添加以下样式 */
html, body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin: 0;
  padding: 0;
  min-height: 100vh; /* 添加这一行 */
}
</style>
